import React from 'react';

const EditDropdown = ({ setSub, value }) => {
  const subjects = JSON.parse(localStorage.getItem('subjects'));

  const handleChange = (e) => {
    const selectedSub = e.target.value;
    const subject = subjects.find((subject) => {
      return subject.name === selectedSub;
    });
    setSub(subject.name);
  };

  return (
    <select onChange={(e) => handleChange(e)}>
      <option value='Select'>{value}</option>
      {subjects.length > 0 &&
        subjects.map((subject) => (
          <option value={subject.name} key={subject.id}>
            {subject.name}
          </option>
        ))}
    </select>
  );
};

export default EditDropdown;
